import { render, staticRenderFns } from "./UIcon.vue?vue&type=template&id=4cb5edde"
import script from "./UIcon.vue?vue&type=script&lang=js"
export * from "./UIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports